const COLUMNS = [
  {
    title: "热门栏目",
    links: [
      { label: "翻车现场精选", href: "#feed" },
      { label: "名场面TOP榜", href: "#top" },
      { label: "尴尬瞬间小剧场", href: "#awkward" },
      { label: "被怼金句", href: "#quotes" },
    ],
  },
  {
    title: "快速导航",
    links: [
      { label: "吃瓜群众口碑", href: "#reviews" },
      { label: "投稿吃瓜", href: "#faq" },
      { label: "常见问题", href: "#faq" },
      { label: "回到顶部", href: "#home" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-white">
      {/* 投稿 CTA */}
      <div className="mx-auto max-w-7xl px-4 pb-16 md:px-6">
        <div className="dot-bg relative overflow-hidden rounded-3xl bg-gradient-to-br from-orange-600 via-orange-500 to-amber-500 p-8 md:p-12">
          <i className="ri-chat-smile-3-fill absolute -right-6 -top-6 text-[160px] text-white/10" />
          <div className="relative flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
            <div>
              <h2 className="font-hand text-2xl leading-snug text-white md:text-4xl">
                你也有难忘的搭讪翻车名场面？
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
                把尴尬变成快乐，把社死变成素材。欢迎把你经历或亲耳听到的翻车瞬间、被怼金句投稿给我们，
                让更多人一起围观这份快乐，投稿一经采用还有机会上名场面TOP榜哦。
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row lg:shrink-0">
              <a
                href="mailto:hello@dashan-chigua.com"
                className="whitespace-nowrap rounded-full bg-white px-7 py-3 text-center text-sm font-bold text-orange-600 transition-colors hover:bg-orange-50"
              >
                <i className="ri-mail-send-line mr-2" />
                投稿吃瓜
              </a>
              <a
                href="#reviews"
                className="whitespace-nowrap rounded-full border border-white/60 px-7 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-white/10"
              >
                看看大家的瓜
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 页脚主体 */}
      <div className="bg-orange-100/70">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-12 md:grid-cols-12 md:px-6 md:py-16">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2" aria-label="搭讪吃瓜">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-orange-500 text-white">
                <i className="ri-chat-smile-3-line text-xl" />
              </span>
              <span className="font-hand text-xl text-stone-800">
                搭讪<span className="text-orange-500">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-stone-500">
              一个专注街头搭讪翻车、被拒名场面与尴尬瞬间的快乐聚集地。把每一次真实的社死，都变成全网围观的名场面，快乐吃瓜，保持善意。
            </p>
            <div className="mt-5 flex items-center gap-3 text-stone-400">
              <a
                href="mailto:hello@dashan-chigua.com"
                aria-label="联系邮箱"
                className="grid h-9 w-9 place-items-center rounded-full bg-white text-stone-500 transition-colors hover:text-orange-600"
              >
                <i className="ri-mail-line text-lg" />
              </a>
              <span className="text-xs">投稿与合作：hello@dashan-chigua.com</span>
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="mb-4 text-sm font-bold text-stone-800">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="whitespace-nowrap text-sm text-stone-500 transition-colors hover:text-orange-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="mb-4 text-sm font-bold text-stone-800">内容声明</h4>
            <p className="text-sm leading-relaxed text-stone-500">
              本网站内容仅用于娱乐与分享，部分内容引用自公开网络并作二次创作盘点。我们尊重原创与隐私，如涉及你的权益，欢迎联系反馈，我们将及时处理。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-stone-400">
              名场面热度榜单数据仅供参考娱乐，不构成任何排名主张。
            </p>
          </div>
        </div>

        <div className="border-t border-orange-200/70">
          <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-stone-500 sm:flex-row md:px-6">
            <p>© 2026 搭讪吃瓜 · 专注搭讪翻车名场面，快乐吃瓜不走空。</p>
            <p className="flex items-center gap-4">
              <span className="whitespace-nowrap">本内容仅供娱乐分享</span>
              <a href="#home" className="whitespace-nowrap text-orange-600 hover:text-orange-700">
                回到顶部 <i className="ri-arrow-up-line" />
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}